import React, { createContext, useState } from "react";
import PropTypes from "prop-types"
export const FormContext = createContext();

export const FormProvider = ({ children }) => {
  const [formData, setFormData] = useState();
  const [address, setAddress] = useState("");
  return (
    <FormContext.Provider
      value={{ formData, setFormData, address, setAddress }}
    >
      {children}
    </FormContext.Provider>
  );
};

FormProvider.propTypes = {
  children : PropTypes.node.isRequired
}